const passkey_sign_in = {
    setup_page: {
        title: 'サインインをもっとシンプルに',
        subtitle: 'パスキーを作成',
        description: 'デバイスの生体認証、YubiKeyなどのセキュリティキー、その他利用可能な方法でパスキーを登録します。',
    },
    trigger_conditional_ui_failed: 'パスキーの自動入力を起動できませんでした。',
};
export default Object.freeze(passkey_sign_in);
